import React, { Fragment, useEffect } from "react";
import { FieldProps } from "@rjsf/core";
import { Tilannekuva } from "../../../../endpoints";
import { useAuthContext } from "../../../../auditoinnit/auth/AuthenticationProvider";
import { TPositionMapping } from "../../mock";
import { MapAuditing } from "../MapAuditing";
import { CheckItemId } from "../MapAuditing.utils";
import { useTargetingScheme } from "../../../../@tilannekuva/data/useTargetingScheme";
import { ITargetingScheme } from "../../../../@tilannekuva/models/TargetingScheme";

const targetingSchemeToPositionMapping = (scheme: ITargetingScheme): TPositionMapping => {
    return Object.keys(scheme.targeting).reduce((acc, key, index) => {
        return {
            ...acc, [key]: {
                fixed: true,
                coordinates: scheme.targeting[key].coordinates,
                status: undefined
            }
        }
    }, {});
};

type TMapAuditingCheck = {
    coordinates: [number, number];
    status?: "kunnossa" | "korjattavaa",
    fixed?: boolean;
};
type TMapAuditingValue = { [key: string]: TMapAuditingCheck };

export const MapAuditingField: React.FC<FieldProps<any>> = (props) => {
    const { token } = useAuthContext();
    const { onChange, uiSchema = {} } = props as any

    const formData: TMapAuditingValue = props.formData ?? {};

    const mapReference = uiSchema["ui:mapReference"] || "tammisairaala_liikennemerkit";
    const titleType = uiSchema["ui:titleType"] || "none" as "key" | "none";


    const { data: targetingResult } = useTargetingScheme(mapReference, Tilannekuva.path, token);
    const { targetingScheme, map } = targetingResult || {}


    useEffect(() => {
        if (!Object.keys(formData).length && targetingScheme && targetingScheme.targeting) {
            onChange(targetingSchemeToPositionMapping(targetingScheme));
        }
    }, [onChange, formData, targetingScheme]);


    const addCheck = (center: [number, number]) => {
        const checkData: TMapAuditingCheck = {
            coordinates: center
        };
        onChange({ ...formData, [CheckItemId()]: checkData })
    };

    const setCheck = (key: string, checkData: TMapAuditingCheck) => {
        onChange({ ...formData, [key]: checkData });
    };

    const removeCheck = (key: string) => {
        const nextFormData = { ...formData };
        delete nextFormData[key];
        onChange(nextFormData)
    };


    if (!token || !map) {
        return <div> No Token </div>
    };


    return (
        <Fragment>
            <MapAuditing
                map={map}
                formData={formData}
                onAddNewCheck={addCheck}
                onSetCheck={setCheck}
                onRemoveCheck={removeCheck}
                titleType={titleType}
            />
        </Fragment >
    )
};
